import PageLayout from "../../components/feature/PageLayout";
import InfoPageHero from "../../components/feature/InfoPageHero";
import InfoPageFinalCTA from "../../components/feature/InfoPageFinalCTA";
import InfoPageFooter from "../../components/feature/InfoPageFooter";
import StepsSection from "./components/StepsSection";
import GuideSection from "./components/GuideSection";
import WorriesSection from "./components/WorriesSection";
import { heroData, finalCTA } from "../../mocks/firstTimeData";

export default function FirstTime() {
  return (
    <PageLayout>
      <InfoPageHero
        label="FIRST TIME"
        title={heroData.title}
        subtitle={heroData.subtitle}
        image={heroData.image}
        alt="初めての方へ"
      />
      <StepsSection />
      <GuideSection />
      <WorriesSection />
      <InfoPageFinalCTA
        title={finalCTA.title}
        subtitle={finalCTA.subtitle}
        ctas={finalCTA.ctas}
      />
      <InfoPageFooter />
    </PageLayout>
  );
}
